import { Fragment, useState } from "react";
import ImageModal from "../HexModal/ImageModal";
import SmartImage from "../SmartImage";

const ClickableImage = ({
  imageSrc,
  title,
  imageClass,
  disableClick,
  size,
  hideShadow,
}) => {
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal((prev) => !prev);
  };

  const renderImageModal = () => {
    if (!modal) return null;

    const image = imageSrc.includes("?size=xs")
      ? imageSrc.replace("?size=xs", `?size=${size || "sm"}`)
      : `${imageSrc}?size=${size || "sm"}`;

    return (
      <ImageModal open={true} imageSrc={image} onCancel={() => toggleModal()} />
    );
  };

  const imageProps = {
    ...(imageSrc && !disableClick && { onClick: toggleModal }),
  };

  return (
    <Fragment>
      {renderImageModal()}
      <SmartImage
        src={imageSrc || "/assets/icons/default-image.jpeg"}
        alt={title || ""}
        width="100%"
        height="100%"
        className={`${hideShadow ? "picture-box-shadow" : ""} ${imageClass} ${
          imageSrc ? "pointer" : ""
        }`}
        {...imageProps}
      />
    </Fragment>
  );
};

export default ClickableImage;
